// Switch between local and production backend
const DeployUrl = "https://toodueappbackend-production.up.railway.app"  // Uncomment for production

export const useUrl = DeployUrl  // Use production backend
// For local development, change to: export const useUrl = 'http://localhost:5001'